// ============================================================
// KEYCLOAK AUTH — Initialize, token management, user info
// ============================================================

import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://corebank.balsham.cloud/auth',
  realm: 'corebank',
  clientId: 'corebank-ui',
});

export function initKeycloak() {
  return new Promise((resolve, reject) => {
    keycloak
      .init({
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: 'S256',
      })
      .then((authenticated) => {
        if (!authenticated) {
          reject(new Error('Authentication failed'));
          return;
        }
        // Auto-refresh token 70s before expiry, check every 10s
        setInterval(() => {
          keycloak.updateToken(70).catch(() => {
            console.warn('Token refresh failed, forcing immediate retry');
            keycloak.updateToken(-1).catch(() => {
              console.warn('Retry also failed, redirecting to login');
              keycloak.login();
            });
          });
        }, 10000);

        resolve();
      })
      .catch(reject);
  });
}

export function getToken() {
  return keycloak.token || '';
}

export function getUser() {
  const parsed = keycloak.tokenParsed || {};
  return {
    username: parsed.preferred_username || 'unknown',
    name: parsed.name || parsed.preferred_username || 'Unknown User',
    roles: parsed.realm_access?.roles || [],
  };
}

export function logout() {
  keycloak.logout({ redirectUri: window.location.origin });
}

export { keycloak };
